import React, { useState, useContext, ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useWindowSize } from "react-use";
import { demoPagesMenu } from "../../menu";
import {
  DropdownItem,
  DropdownMenu,
} from "../../components/bootstrap/Dropdown";
import Button from "../../components/bootstrap/Button";
import useDarkMode from "../../hooks/useDarkMode";
import Collapse from "../../components/bootstrap/Collapse";
import { NavigationLine } from "../Navigation/Navigation";
import Icon from "../../components/icon/Icon";
import useNavigationItemHandle from "../../hooks/useNavigationItemHandle";
import AuthContext from "../../contexts/authContext";
import ThemeContext from "../../contexts/themeContext";
import { AppDispatch } from "../../store/store";
import { persistor } from "../../store/store";
import { resetApiState, clearDashboardMenu } from "../../store/apiSlice";
import { resetDashboardUserState } from "../../store/dashboardForUserId";
import { useDispatch } from "react-redux";

const User = () => {
  const { width } = useWindowSize();
  const { setAsideStatus } = useContext(ThemeContext);
  const { userData, setUser } = useContext(AuthContext);
  const userInfo: any = localStorage.getItem("userInfo");
  const userName = JSON.parse(userInfo).userName;
  const userEmail = JSON.parse(userInfo).email;
  const user_id = JSON.parse(userInfo).userId;
  const navigate = useNavigate();
  const handleItem = useNavigationItemHandle();
  const { darkModeStatus, setDarkModeStatus } = useDarkMode();

  const [collapseStatus, setCollapseStatus] = useState<boolean>(false);

  const { t } = useTranslation(["translation", "menu"]);
  useEffect(() => {
    console.log(
      "This is inside user function use Effect:...",
      JSON.parse(userInfo)
    );
    console.log("This is inside user id: ", user_id);
  });

  const dispatch: AppDispatch = useDispatch();

  const handleLogout = async () => {
    if (setUser) {
      setUser("");
    }
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("companyInfo");
    localStorage.removeItem("widgetsFormData");
    localStorage.removeItem("rolesFormData");
    localStorage.removeItem("queryToolFormData");
    localStorage.removeItem("queryToolQPList");
    localStorage.removeItem("groupsFormData");
    localStorage.removeItem("dataSourceFormData");
    localStorage.removeItem("facit_asideStatus");
    localStorage.removeItem("facit_darkModeStatus");
    // localStorage.removeItem("persist:dashboards");
    // localStorage.clear();
    dispatch(clearDashboardMenu());
    dispatch(resetApiState());
    dispatch(resetDashboardUserState());

    await persistor.purge();

    navigate(`../${demoPagesMenu.login.path}`);
  };
  return (
    <>
      <div
        className={classNames("user", { open: collapseStatus })}
        role="presentation"
        onClick={() => setCollapseStatus(!collapseStatus)}
      >
        <div className="user-avatar">
          <img
            srcSet={userData?.srcSet}
            src={userData?.src}
            alt="Avatar"
            width={128}
            height={128}
          />
        </div>
        <div className="user-info">
          <div className="user-name d-flex align-items-center">
            {`${userName} `}
            <Icon icon="Verified" className="ms-1" color="info" />
          </div>
          <div className="user-sub-title">{userEmail}</div>
        </div>
      </div>
      <DropdownMenu>
        <DropdownItem>
          <div
            // icon="AccountBox"
            onClick={() => navigate(`/profile`)}
          >
            Profile
          </div>
        </DropdownItem>
        <DropdownItem>
          <Button
            icon={darkModeStatus ? "DarkMode" : "LightMode"}
            onClick={() => setDarkModeStatus(!darkModeStatus)}
            aria-label="Toggle fullscreen"
          >
            {darkModeStatus ? "Dark Mode" : "Light Mode"}
          </Button>
        </DropdownItem>
      </DropdownMenu>

      <Collapse isOpen={collapseStatus} className="user-menu">
        <nav aria-label="aside-bottom-user-menu">
          <div className="navigation">
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() =>
                navigate(
                  `/profile`,
                  // @ts-ignore
                  handleItem()
                )
              }
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon icon="AccountBox" className="navigation-icon" />
                  <span className="navigation-text">
                    {t("menu:Profile") as ReactNode}
                  </span>
                </span>
              </span>
            </div>
            {/* <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() => {
                setDarkModeStatus(!darkModeStatus);
                handleItem();
              }}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon
                    icon={darkModeStatus ? "DarkMode" : "LightMode"}
                    color={darkModeStatus ? "info" : "warning"}
                    className="navigation-icon"
                  />
                  <span className="navigation-text">
                    {darkModeStatus
                      ? (t("menu:DarkMode") as ReactNode)
                      : (t("menu:LightMode") as ReactNode)}
                  </span>
                </span>
              </span>
            </div> */}
          </div>
        </nav>
        <NavigationLine />
        <nav aria-label="aside-bottom-user-menu-2">
          <div className="navigation">
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={
                handleLogout
                //   () => {
                //   if (setUser) {
                //     setUser("");
                //   }
                //   if (
                //     width < Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)
                //   ) {
                //     setAsideStatus(false);
                //   }
                //   navigate(`../${demoPagesMenu.login.path}`);
                // }
              }
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon icon="Logout" className="navigation-icon" />
                  <span className="navigation-text">
                    {t("menu:Logout") as ReactNode}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </nav>
      </Collapse>
    </>
  );
};

export default User;
